import React from 'react';
import { Tooltip, Typography } from '@mui/material';

function ItemNameDisplay({item}) {
    return (
        <Typography 
            variant='normal' 
            sx={{ fontSize: '16px' }}
        >
            {item.is_active === false &&
                <>
                    <Typography variant='normal' color='error' sx={{ fontSize: '16px', opacity: 1.0 }}>Inactive</Typography>
                    <Typography variant='normal' sx={{ fontSize: '16px' }}> - </Typography>
                </>
            }
            { (item.system_name !== null && item.system_name !== item.name) ? 
                <Tooltip title={item.system_name} placement='top' arrow>
                    {item.name}
                </Tooltip>
                :
                <>{item.name}</>
            }    
        </Typography>
    );
}

export default ItemNameDisplay;
